import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M11.5 17h-7.5a1 1 0 0 1 -1 -1v-12a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v9","key":"svg-0"}],["path",{"d":"M3 13h18","key":"svg-1"}],["path",{"d":"M8 21h3.5","key":"svg-2"}],["path",{"d":"M10 17l-.5 4","key":"svg-3"}],["path",{"d":"M20 21l2 -2l-2 -2","key":"svg-4"}],["path",{"d":"M17 17l-2 2l2 2","key":"svg-5"}]]

const IconDeviceImacCode = createReactComponent('outline', 'device-imac-code', 'DeviceImacCode', __iconNode);

export default IconDeviceImacCode;